import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {AppContainer} from 'react-hot-loader';
import ShortlistSideMenu from './ShortlistSideMenu/ShortlistSideMenu';
import BookingForm from './BookingForm/BookingForm';
import 'react-dates/initialize';
import {combineReducers} from 'redux-immutable';
import bookingProcessSidebar from './BookingProcessSidebar/reducer';
import partyDetails from './PartyDetails/reducer';
import shortlistSideMenu, {INITIAL_STATE as shortlistSideMenuInitialState} from './ShortlistSideMenu/reducer';
import bookingForm, {INITIAL_STATE as bookingFormInitialState} from './BookingForm/reducer';
import {Map} from 'immutable';
import makeStore from './redux-config/store';
import '../modules/shims';


const peakRetreatsStore = makeStore(combineReducers({
/*  availabilityResults,*/

  bookingForm,
  bookingProcessSidebar,
  shortlistSideMenu,
/*  skiExtras,*/
  partyDetails,
}), Map({
/*  skiExtras: skiExtrasInitialState,*/
  shortlistSideMenu: shortlistSideMenuInitialState,
  bookingForm: bookingFormInitialState
}));

const getRenderFunc = app => {
  return () => {
    if (app.element === null) {
      return;
    }
    render(app.component, app.element, app.name);
  };
};


const render = (Component, element, name) => {
  ReactDOM.render(
    <AppContainer name={name}>
      {Component}
    </AppContainer>,
    element
  );
};

const apps = [];

const elements = {
  shortlistSideMenu: document.getElementById('shortlist-side-menu__anchor'),
  bookingForm: document.getElementById('booking-form__react-anchor'),
};





if (elements.bookingForm !== null) {
  apps.push({
    element: elements.bookingForm,
    component: <Provider store={peakRetreatsStore}>
      <BookingForm initialData={elements.bookingForm.getAttribute('data-initial-data')}
                   thisSeasonStartDate={elements.bookingForm.getAttribute('data-this-season-start')}
                   thisSeasonEndDate={elements.bookingForm.getAttribute('data-this-season-end')}
                   nextSeasonStartDate={elements.bookingForm.getAttribute('data-next-season-start')}
                   nextSeasonEndDate={elements.bookingForm.getAttribute('data-next-season-end')}
                   preselectedRegion={elements.bookingForm.getAttribute('data-preselectedRegion')}
                   telephoneNumber={elements.bookingForm.getAttribute('data-telephoneNumber')}
                   preselectedResort={elements.bookingForm.getAttribute('data-preselectedResort')}
                   premium={elements.bookingForm.getAttribute('data-premium') === 'true'}
                  selectedDateString={''}
                   altArrivalDateMessage={elements.bookingForm.getAttribute('data-altArrivalDateMessage')}
                   showAlternativeArrivalDates={elements.bookingForm.getAttribute('data-showAltArrivalDate')}
                   preselectedAccommodation={elements.bookingForm.getAttribute('data-preselectedAccommodation')}/>
    </Provider>
  });
}

if (elements.shortlistSideMenu !== null) {
  apps.push({
    element: elements.shortlistSideMenu,
    component: <Provider store={peakRetreatsStore}><ShortlistSideMenu
      initialData={elements.shortlistSideMenu.getAttribute('data-initialdata')}/></Provider>
  });
}


for (const a of apps) {
  a.element ? getRenderFunc(a)() : null;
  module.hot ? module.hot.accept(getRenderFunc(a)()) : null;
}
